// Direct reports — the reporting-manager relationship read straight off
// profiles.manager_id, for My Space's "Credit hours to your team" card. A
// manager may hold people:none and have no /hr to go to at all; profiles_read
// (20260604000000_rbac_dynamic.sql:142-143) still lets them read these rows,
// because the seeded matrix gives every role but contractor and client at
// least talent:view, which that policy ORs in beside people:view and self.
// The credit itself is lib/compHours.ts's grantHours, which the trigger allows
// for the reporting manager (20260902120000, 41_comp_hours_grant.test.sql).
import { supabase } from './supabase';

export type DirectReport = { id: string; full_name: string | null };

/**
 * This viewer's own active reports, by name. 'active' drops leavers
 * ('inactive'), erased people ('archived') and service accounts ('system'),
 * as the Reports to picker does. `failed` marks a read that errored, in
 * compHours.listMine's shape: a failed read is not "no reports" (§7).
 */
export async function listDirectReports(
  managerId: string,
): Promise<DirectReport[] & { failed?: true }> {
  if (!supabase) return [];
  const { data, error } = await supabase
    .from('profiles')
    .select('id, full_name')
    .eq('manager_id', managerId)
    .eq('status', 'active')
    .order('full_name');
  if (error) return Object.assign([], { failed: true as const });
  return (data as DirectReport[]) ?? [];
}
